export const SPACES = [
  {
    id: 'hot-desk',
    name: 'Hot Desk',
    type: 'desk',
    color: '#3b82f6',
    bgColor: '#eff6ff',
    capacity: 1,
    totalSeats: 6,
    seats: ['Hot Desk 1', 'Hot Desk 2', 'Hot Desk 3', 'Hot Desk 4', 'Hot Desk 5', 'Hot Desk 6'],
    pricingOptions: [
      { label: 'Day Pass', type: 'daily', price: 25, meetingRoomCredits: 1 },
      { label: 'Monthly Membership', type: 'monthly', price: 200 },
    ],
    description: 'Flexible open-plan desks on a first-come, first-served basis. Perfect for remote workers, freelancers, or anyone needing a professional workspace for a day.',
    amenities: ['High-speed Wi-Fi', 'Ergonomic chair', 'Power outlets', 'Printing access', 'Kitchen access', 'Lounge area'],
    image: null,
    minDuration: 1,
    durationUnit: 'day',
  },
  {
    id: 'dedicated-desk',
    name: 'Dedicated Office',
    type: 'desk',
    color: '#8b5cf6',
    bgColor: '#f5f3ff',
    capacity: 1,
    totalSeats: 4,
    seats: ['Dedicated Office A', 'Dedicated Office B', 'Dedicated Office C', 'Dedicated Office D'],
    pricingOptions: [
      { label: 'Day Rate', type: 'daily', price: 60 },
      { label: 'Monthly Membership', type: 'monthly', price: 350 },
    ],
    description: 'Your own permanent, lockable desk in our open workspace. Store your equipment and personalise your space. Ideal for regular members who need a consistent workspace.',
    amenities: ['High-speed Wi-Fi', 'Dedicated monitor available', 'Lockable pedestal', 'Ergonomic chair', 'Business address use', 'Kitchen access', '24/7 access'],
    image: null,
    minDuration: 1,
    durationUnit: 'month',
  },
  {
    id: 'meeting-room',
    name: 'Meeting Room',
    type: 'room',
    color: '#10b981',
    bgColor: '#ecfdf5',
    capacity: 8,
    totalSeats: 1,
    pricingOptions: [
      { label: 'Per Hour', type: 'hourly', price: 35 },
      { label: 'Full Day', type: 'daily', price: 200 },
    ],
    description: 'Professional meeting room seating up to 8 people with a large display screen, whiteboard, and video conferencing capabilities. Perfect for client meetings, workshops, and team sessions.',
    amenities: ['65" display screen', 'Video conferencing', 'Whiteboard', 'High-speed Wi-Fi', 'Climate control', 'Tea & coffee', 'Catering available'],
    image: null,
    minDuration: 1,
    durationUnit: 'hour',
  },
];

export const getSpaceById = (id) => SPACES.find((s) => s.id === id);

export const MEMBERSHIP_PLANS = [
  {
    id: 'casual',
    name: 'Casual',
    price: 25,
    period: 'per day',
    description: 'Hot desk day passes, no commitment',
    features: ['Hot desk access', 'Wi-Fi & printing', 'Kitchen access', 'Pay as you go'],
    highlighted: false,
    spaceId: 'hot-desk',
    pricingType: 'daily',
  },
  {
    id: 'member',
    name: 'Member',
    price: 200,
    period: 'per month',
    description: 'Unlimited hot desk access all month',
    features: ['Unlimited hot desk', 'Wi-Fi & printing', 'Kitchen access', 'Business address', '2 meeting room hrs/mo'],
    highlighted: true,
    spaceId: 'hot-desk',
    pricingType: 'monthly',
  },
  {
    id: 'dedicated',
    name: 'Dedicated',
    price: 350,
    period: 'per month',
    description: 'Your own permanent private office, locked and secure',
    features: ['Dedicated private office', '24/7 access', 'Business address', 'Storage included', '4 meeting room hrs/mo'],
    highlighted: false,
    spaceId: 'dedicated-desk',
    pricingType: 'monthly',
  },
];
